import React from 'react';
import { useLang } from '../i18n/LangContext';
import Reveal from './Reveal';
import { IMG } from '../data/realImages';

const ABOUT_IMG = IMG.construction[1] || IMG.construction[0];

export default function About() {
  const { t } = useLang();
  const pillars = t('about.pillars');

  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-40 border-t border-[#27272A]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          {/* Left index */}
          <div className="md:col-span-4">
            <Reveal className="section-index">{t('about.index')}</Reveal>
            <Reveal className="mt-8 hidden md:block reveal-delay-1">
              <div className="aspect-[3/4] w-full overflow-hidden border border-[#27272A]">
                <img
                  src={ABOUT_IMG}
                  alt="ALPHA 7 industrial operations"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="mt-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA]">
                MX — Industrial Operations
              </div>
            </Reveal>
          </div>

          {/* Right content */}
          <div className="md:col-span-8">
            <Reveal as="h2" className="h-section text-[#F5F5F2]">
              {t('about.title_pre')} <span className="text-[#C8102E]">{t('about.title_accent')}</span> {t('about.title_post')}
            </Reveal>

            <Reveal className="mt-10 text-lg md:text-xl text-[#A1A1AA] leading-relaxed max-w-3xl reveal-delay-1">
              {t('about.body_1')}
            </Reveal>
            <Reveal className="mt-6 text-base md:text-lg text-[#A1A1AA] leading-relaxed max-w-3xl reveal-delay-2">
              {t('about.body_2')}
            </Reveal>

            {/* Pillars */}
            <Reveal className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#27272A] border border-[#27272A] reveal-delay-3">
              {pillars.map((p, i) => (
                <div key={p} className="bg-[#0F0F11] p-5 md:p-6 flex flex-col">
                  <span className="font-mono text-[10px] tracking-[0.3em] text-[#C8102E]">0{i + 1}</span>
                  <span className="mt-3 font-display text-base md:text-lg tracking-tight text-[#F5F5F2]">{p}</span>
                </div>
              ))}
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
